export const isHorizontallyStretched = (compLayout) => !!(compLayout.docked?.right && compLayout.docked?.left);
//# sourceMappingURL=layoutUtils.js.map